<template>
    <Dialog v-model:visible="visible" :style="{ width: '300px' }" :header="dialogHeader" :modal="true" class="p-fluid dialog-header" @hide="$emit('hide-dialog', true)">
        <div class="field">
            <label for="name">Appliance Name:</label>
            <InputText :class="{ 'p-invalid': submitted && !appliance.name }" id="name" type="text" v-model="appliance.name" autofocus />
            <small class="p-invalid" v-if="submitted && !appliance.name">Appliance Name is required</small>
        </div>

        <template #footer>
            <Button label="Cancel" icon="pi pi-times" class="p-button-danger" @click="visible = false" />
            <Button label="Submit" icon="pi pi-check" class="p-button-success" @click="submit" />
        </template>
    </Dialog>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { ref, defineEmits, computed, onUnmounted } from 'vue';
import { object, string } from 'yup';
import { applianceStore } from '../../../../../store/global-stores';
import { showToast } from '../../../../../utilities/toast-handler';

// emit
const emit = defineEmits(['hide-dialog']);

const visible = ref(true);
const submitted = ref(false);

const { appliance, editId } = storeToRefs(applianceStore);

onUnmounted(() => {
    applianceStore.initAppliance();
});

// computed properties starts
const dialogHeader = computed(() => {
    return editMode.value ? 'Update Existing Appliance' : 'Add New Appliance';
});

const editMode = computed(() => {
    return editId.value;
});

const validationSchema = object({
    name: string().required('Appliance Name is required'),
});

const submit = async () => {
    try {
        submitted.value = true;
        await validationSchema.validate(appliance.value, { abortEarly: false });
        const response = editMode.value ? await applianceStore.updateAppliance() : await applianceStore.createAppliance();
        if (response) {
            emit('hide-dialog');
        }
    } catch (error) {
        if (error.inner && typeof error.inner === 'object') {
            showToast({}, 'Input data invalid');
        }
    }
};
</script>
